/**
 * Generates a unique key for React components in reports tables using duck typing
 * Handles all report item types: TopSellingProducts, TopCustomers, SoldProducts, SoldSubscriptions, etc.
 *
 * @param item - The report item to generate a key for
 * @param fallbackIndex - Index to use as fallback if no unique identifier is found
 * @returns A unique string key
 */
export const generateReportsTableItemKey = (
  item: any,
  fallbackIndex: number
): string => {
  // TopSellingProducts items
  if (item.deviation?.deviationid) {
    return `deviation-${item.deviation.deviationid}`;
  }
  if (item.premiumGallery?.folderid) {
    return `folder-${item.premiumGallery.folderid}`;
  }

  // TopCustomers items
  if (item.user?.userid) {
    return `user-${item.user.userid}`;
  }

  // SoldSubscriptions items
  if (item.deviation?.deviationid && item.productName) {
    return `subscription-${item.deviation.deviationid}-${item.productName}`;
  }

  // SoldProducts items (aggregated by productType)
  if (item.productType) {
    return `product-${item.productType}`;
  }

  // SoldExclusives items
  if (item.exclusiveType) {
    return `exclusive-${item.exclusiveType}`;
  }

  // TopSubscribers items
  if (item.user?.userid && item.deviation?.deviationid) {
    return `subscriber-${item.user.userid}-${item.deviation.deviationid}`;
  }

  // Generic fallbacks
  if (item.id) return `id-${item.id}`;
  if (item.productName) return `name-${item.productName}`;

  // Final fallback to index-based key
  return `index-${fallbackIndex}`;
};
